<template>
  <div class="menu-main">
    <div class="menu-head">
      <img class="menu-logo" :src="fullImage(config.apply_logo)" alt="">
      <div class="name">{{config.apply_name}}</div>
    </div>
    <div class="menu-item" v-for="(item,index) in menuItem" :key="index"
      :class="{'active':isActive==index,'select':isActive==index && item.children.length}">
      <a href="javascript:;" class="menu-a" @click="selectMenu(index)">
        <i class="menu-icon iconfont" :class="item.thumb"></i>
        <span class="menu-label" v-if="menuMode=='default'">{{item.title}}</span>
        <i v-if="menuMode=='default'" class="menu-down" :class="{'iconfont icon-xiala1':item.children.length}"></i>
      </a>
      <div class="children" v-if="menuMode=='default'">
        <div class="c-item" v-for="(items,keys) in item.children" :key="keys">
          <a class="c-item-a" :class="{'sel-a':isChildren==keys}" href="javascript:;"
            @click="openUrl(items,keys)">{{items.title}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "LeftMenu",
    data() {
      return {
        ImgUrl: this.ImgUrl,
        menuMode: 'default',
        menuItem: [],
        isActive: -1,
        isSelect: -1,
        isChildren: -1,
        config: {
          apply_logo: '',
          apply_name: ''
        }
      }
    },
    created() {
      this.init();
    },
    methods: {
      //获取栏目
      init() {
        var _this = this;
        this.requestApi('/adm/get_private_menu').then(function(res) {
          if (res.code == 200) {
            _this.menuItem = res.data;
            _this.config = res.config
            localStorage.setItem('SYSTEM_PERMIT', JSON.stringify(res.role_ids))
          }
        })
      },
      selectMenu(key) {
        this.isSelect = false;
        if (this.isActive == key) this.isActive = -1;
        else this.isActive = key;
        if (!this.menuItem[key].children.length) this.toUrl(this.menuItem[key].path);
      },
      openUrl(item, index) {
        this.isChildren = index;
        if (!item.path) return false;
        else this.toUrl(item.path);
      },
      changeIndex() {
        this.isActive = -1;
        this.isChildren = -1;
        this.isSelect = true;
        this.toUrl('/private/apply_list');
      },
    }
  }
</script>

<style scoped>
  /* left-menu */
  .menu-main {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    padding-top: 16px;
    width: 180px;
    height: 100%;
    background: #24303c;
    z-index: 99;
    transition: all 0.3s ease-in-out;
    overflow: hidden;
  }

  .menu-head {
    text-align: center;
  }

  .menu-logo {
    width: 48px;
    height: 48px;
  }

  .name {
    font-size: 13px;
    color: #FFFFFF;
    margin-top: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-bottom: 16px;
  }

  .menu-item {
    width: 180px;
    height: auto;
  }

  .small {
    width: 43px !important;
  }

  .menu-a {
    display: block;
    padding: 0 15px;
    width: auto;
    height: 45px;
    line-height: 45px;
    text-align: left;
    font-size: 13px;
    color: hsla(0, 0%, 100%, .65) !important;
    position: relative;
  }

  .active .menu-a:before {
    display: block;
    content: "";
    position: absolute;
    right: 0;
    top: 12px;
    width: 4px;
    height: 20px;
    background: #FFFFFF;
    border-radius: 2px;
  }

  .select .menu-a:before {
    display: none !important;
  }

  .select .menu-a:hover:before {
    display: block !important;
  }

  .menu-a:hover {
    color: #FFFFFF !important;
  }

  .active:before {
    transform: rotate(180deg);
  }

  .menu-a .menu-down {
    display: block;
    position: absolute;
    right: 16px;
    top: 0px;
    transition: all 0.3s;
  }

  .active .menu-down {
    transform: rotate(180deg);
  }

  .menu-a:hover {
    color: #FFFFFF;
  }

  .menu-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 6px;
    vertical-align: top;
  }

  .children {
    display: none;
  }

  .c-item-a {
    display: block;
    padding: 0 35px;
    height: 45px;
    line-height: 45px;
    text-align: left;
    font-size: 13px;
    color: hsla(0, 0%, 100%, .65) !important;
    position: relative;
  }

  .sel-a:before {
    display: block;
    content: "";
    position: absolute;
    right: 0;
    top: 12px;
    width: 4px;
    height: 20px;
    background: #FFFFFF;
    border-radius: 2px;
  }

  .c-item-a:hover {
    color: #FFFFFF !important;
  }

  .active .children {
    display: block !important;
    padding-left: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/privateMenu.vue